import React, {useLayoutEffect, useRef, useState} from "react";
import { useDispatch } from "react-redux";
import { SEARCH_MODEL } from "../../../../../components/table/Model/TableModel";
import { SimpleSearch } from "../../../../../reduxToolkit/Search/SearchApi";
import TableFunction from "../../../../../components/table/TableFunction";
import { TABLES } from '../../../../../Apis/Tables';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const CommonAreaTableApp = (
    {
        results,
        setResults,
        searchElement
    }
) => {
    const dispatch = useDispatch();
    const elementRef = useRef(null);
    const [modified, setModified] = useState(false);

    const option = TABLES.COMMON_AREA;
    const tableId = "tbl_cat_common_area";
    const searchId = "txt_cat_common_area";


    /**
     * Function for controlling view sizes
     */
    useLayoutEffect(() => {
        if (elementRef?.current) {
            const rect = elementRef.current.getBoundingClientRect();
            const distanceTop = rect.top + 90;
            elementRef.current.style.setProperty('--top-value', `${distanceTop}px`);
        }
    }, [results?.content]);

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = page => {
        const body = SEARCH_MODEL.setObject({ page, size: rowsPerPage, key: searchElement, model: option });
        dispatch(SimpleSearch({ body })).then(({ payload: { data: { data, success } } }) => {
                if (success === true) {
                    setResults(data);
                }
            },
        );
    };

    /**
     * Function for build table
     */
    const { t, pagination, page, rowsPerPage } = TableFunction({
        data: results,
        labelRowsPerPage: 'common_areas_per_page',
        hasContainer: true,
        fixedPagination: false,

        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });

    return {
        t,
        tableId,
        searchId,
        pagination,
        option,
        page,
        rowsPerPage,
        elementRef
    };

}

export default CommonAreaTableApp;
